const up = (
  <path
    d="M12 6L8 2L4 6"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
export default up;
